import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { CRMSettingsApiAdapter, UpdateCRMSettingsRequest } from '../adapters/CRMSettingsApiAdapter';

export const useUpdateCRMSettings = () => {
  const apiAdapter = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    return new CRMSettingsApiAdapter(httpClient);
  }, []);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateCRMSettingsRequest) => apiAdapter.updateCRMSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['client'] });
      // Invalidar /me para refrescar los settings en el store
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });
};

